import { css, fillOutlined, circle } from './draw-utils';
import type { ProceduralDef } from '../types';

const SILVER = 0xe6e9f0; // neutral facet — tinted per element phase in code

/**
 * B11 Avatar — Unified Form (finale+). A prismatic crown of five facets
 * around a bright core; the body is drawn NEUTRAL so the boss can be tinted
 * to whichever Elemental phase is active. docs/02 Elementals finale.
 */
export const bossAvatarBody: ProceduralDef = {
  key: 'boss/avatar/body',
  width: 150,
  height: 150,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 1,
  draw(ctx, w, h) {
    const c = w / 2;

    // Bright unifying halo
    const halo = ctx.createRadialGradient(c, c, 18, c, c, c);
    halo.addColorStop(0, 'rgba(255,255,255,0.35)');
    halo.addColorStop(1, 'rgba(255,255,255,0)');
    circle(ctx, c, c, c);
    ctx.fillStyle = halo;
    ctx.fill();

    // Five orbiting element facets (diamonds)
    const facets = 5;
    for (let i = 0; i < facets; i++) {
      const a = (Math.PI * 2 * i) / facets - Math.PI / 2;
      const fx = c + Math.cos(a) * 46;
      const fy = c + Math.sin(a) * 46;
      const s = 13;
      ctx.beginPath();
      ctx.moveTo(fx, fy - s);
      ctx.lineTo(fx + s, fy);
      ctx.lineTo(fx, fy + s);
      ctx.lineTo(fx - s, fy);
      ctx.closePath();
      fillOutlined(ctx, SILVER, 4);
    }

    // Faceted core — octagon with an inner gem
    const core: Array<[number, number]> = [];
    for (let i = 0; i < 8; i++) {
      const a = (Math.PI * 2 * i) / 8 + Math.PI / 8;
      core.push([c + Math.cos(a) * 34, c + Math.sin(a) * 34]);
    }
    ctx.beginPath();
    core.forEach(([x, y], i) => (i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y)));
    ctx.closePath();
    fillOutlined(ctx, SILVER, 5);

    // Inner prism gem
    circle(ctx, c, c, 16);
    ctx.fillStyle = css(0xffffff);
    ctx.fill();
    circle(ctx, c - 4, c - 4, 5);
    ctx.fillStyle = 'rgba(255,255,255,0.95)';
    ctx.fill();
    void h;
  },
};
